import { render, staticRenderFns } from "./DriverBlackListDetail.vue?vue&type=template&id=9859905a&scoped=true"
import script from "./DriverBlackListDetail.vue?vue&type=script&lang=js"
export * from "./DriverBlackListDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9859905a",
  null
  
)

export default component.exports